


































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import moment from 'moment';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'
import DeliveryZoneMaster from './DeliveryZoneMaster.vue'

const AUTO_REFRESH_INTERVAL_MS = 30000;

const BOARD_LOG_LEVELS: Record<string, number> = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
};

function boardLog(level: 'debug' | 'info' | 'warn' | 'error', message: string, data?: any) {
  const configured = (
    process.env.VUE_APP_LOG_LEVEL ||
    process.env.LOG_LEVEL ||
    'debug'
  ).toLowerCase();
  const minLevel = BOARD_LOG_LEVELS[configured] ?? BOARD_LOG_LEVELS.debug;
  if ((BOARD_LOG_LEVELS[level] ?? 10) < minLevel) {
    return;
  }
  let fn: (...args: any[]) => void = console.log;
  if (level === 'error') {
    fn = console.error;
  } else if (level === 'warn') {
    fn = console.warn;
  }
  if (data !== undefined) {
    fn(message, data);
  } else {
    fn(message);
  }
}

@Component({
  computed: {
    ...mapState('ubic', [
      'actor'
    ]),

    ...mapState(STORE_KEY, [
      'deliveryDate', 'cityId',
      'dataRequested', 'dataLoading', 'dataLoaded', 'dataRefreshing',
      'computedZones', 'by'
    ]),
    ...mapGetters(STORE_KEY, [
      'allInstanceIds', 'countDeliverySheetInit'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'printFullXLSX', 'printFullPDF', 'printPDF'
    ])
  },
  components: {
    TitleBar,
    DeliveryZoneMaster
  }
})
export default class DeliverySheetBoard extends Vue {

  actor!: any;
  filter!: any;
  employees!: any[];

  deliveryDate!: any;
  cityId!: any;
  dataRequested!: boolean;
  dataLoading!: boolean;
  dataLoaded!: boolean;
  dataRefreshing!: boolean;
  computedZones!: any[];
  by!: string;
  allInstanceIds!: any[];
  countDeliverySheetInit!: number;

  autoRefreshTimer: ReturnType<typeof setInterval> | null = null;
  
  get titleStack () {
    return [
      'Маршрутные листы'
    ]
  }

  changeFilterValue({field, newValue}: any) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        [field]: field == 'deliveryDate' ? moment(newValue).format('YYYY-MM-DD') : newValue
      }
    })
  }

  stopAutoRefresh() {
    if (this.autoRefreshTimer != null) {
      boardLog('debug', '[DeliverySheetBoard] stop polling', {
        intervalMs: AUTO_REFRESH_INTERVAL_MS,
        cityId: this.cityId,
        deliveryDate: this.deliveryDate,
      });
      clearInterval(this.autoRefreshTimer);
      this.autoRefreshTimer = null;
    }
  }

  startAutoRefresh() {
    this.stopAutoRefresh();

    if (!this.cityId || !this.deliveryDate || !this.dataLoaded) {
      boardLog('debug', '[DeliverySheetBoard] polling not started', {
        cityId: this.cityId,
        deliveryDate: this.deliveryDate,
        dataLoaded: this.dataLoaded,
      });
      return;
    }

    boardLog('debug', '[DeliverySheetBoard] start polling', {
      intervalMs: AUTO_REFRESH_INTERVAL_MS,
      cityId: this.cityId,
      deliveryDate: this.deliveryDate,
      by: this.by,
    });

    this.autoRefreshTimer = setInterval(() => {
      boardLog('debug', '[DeliverySheetBoard] polling tick', {
        cityId: this.cityId,
        deliveryDate: this.deliveryDate,
        by: this.by,
        dataLoading: this.dataLoading,
        dataRefreshing: this.dataRefreshing,
      });
      this.$store.dispatch(`${STORE_KEY}/loadDeliverySheetData`, {
        cityId: this.cityId,
        deliveryDate: this.deliveryDate,
        by: this.by,
        silent: true,
      });
    }, AUTO_REFRESH_INTERVAL_MS);
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange()
  }

  public beforeDestroy() {
    this.stopAutoRefresh();
    if (this.dataRefreshing) {
      this.$store.commit(`${STORE_KEY}/FINISH_DATA_REFRESH`);
    }
  }
  
  // ---------------------------------------------------------------------------

  @Watch('dataLoading')
  public onDataLoadingChanged(loading: boolean) {
    if (loading) {
      this.stopAutoRefresh();
      return;
    }
    if (this.dataLoaded && this.cityId && this.deliveryDate) {
      this.startAutoRefresh();
    }
  }

  @Watch('$route.query')
  public handleParamsChange() {
    this.stopAutoRefresh();
    this.$store.dispatch(`${STORE_KEY}/setFilterValue`, {
        ...this.$route.query
      });
  }

}
